<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>

  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
</div>
<!-- <div class="not_added" *ngIf="emptyMsg">
    <div class="user_img"><img src="./assets/img-new/client.png" alt="client"></div>
    <h4>No client added yet</h4>
  </div> -->

<div class="Content_outer" style="display: flex; align-items: center; justify-content: center;">
  <!-- <div class="legendbox" style="margin: 10px;">
        <div style="background-color:#999999"></div><strong>Offline</strong>
        <div style="background-color:#72FF13"></div><strong>Healthy/OFF</strong>
        <div style="background-color:#FAA700"></div><strong>Unsatisfactory</strong>
        <div style="background-color:#ff2a1b"></div><strong>Unacceptable/ON</strong>
    </div> -->
  <div class="outer_frame">
    <div style="margin: 10px; float: right; margin: 17px 10px;">{{ updated_at }}</div>
    <h3 style="position: absolute; margin: 60px">{{ subsystem_name }}</h3>

    <img
      class="eboilerImg"
      src="./assets/products-coil-tube-steam-boiler.png"
      alt=""
    />
    <!---boiler room parameter-->
    <div class="boiler-room-parameter">
      <h5 style="font-weight: 900px !important">Boiler Room Parameters</h5>
      <div *ngFor="let parameter of parameterType">
        <button
          (click)="moveOnDashboard(clientId, subsystemId, subsystem_name)"
          [style.background]="parameter.color"
        >
          <p>{{ parameter.name }}</p>
          <span style="margin-top: -15px"
            ><span *ngIf="parameter.value < 0; else notzero">N/A</span
            ><ng-template #notzero
              >{{ parameter.value }} {{ parameter.unit }}</ng-template
            >
          </span>
        </button>
      </div>
      <button style="color: black; font-weight: 700; font-size: 17px !important;" (click)="getMoreParameters()">More Parameters</button>
    </div>
    <!---boiler room parameter end-->

    <div class="col-md-4" style="height: 432px; margin: 147px 39px">
      <ng-container *ngIf="deviceLoader; else barchartTemplate">
        <div class="spinner-container" style="margin: 140px">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
      </ng-container>
      <div class="no_device" *ngIf="showEmptyError !== ''">
        <p style="color: #838383; padding: 90px">{{ showEmptyError }}</p>
      </div>
      <div class="content_view" #barchartTemplate>
        <div class="row">
          <div class="boxes_outer" style="margin: 0 -13px ;width: 200% !important; max-width: 200% !important;">
            <div
              *ngFor="let device of allDeviceSecondArray; let i = index"
              style="height: 186px !important"
              class="box green_bg"
              [style.background-color]="device.color"
            >
              <div class="statusSymbol">
                <span
                  *ngIf="device.asset_status === 0 || device.asset_status === 2"
                  class="seen"
                >
                  <img
                    matTooltip="Asset Idle"
                    style="height: 10px; width: 10px"
                    src="./assets/images/red.png"
                    [matTooltipClass]="'tooltip1'"
                /></span>

                <span *ngIf="device.asset_status === 1" class="seen">
                  <img
                    matTooltip="Asset Running"
                    style="height: 10px; width: 10px"
                    src="./assets/images/green.png"
                    [matTooltipClass]="'tooltip1'"
                  />
                </span>
              </div>
              <div class="data">
                <h4 class="name bl_color">{{ device.name }}</h4>
                <!-- <p class="num smoke_color">{{device?.motor_serial_no || 'N/A'}}</p> -->
                <p
                  class="num"
                  *ngFor="let sensor of device.connected_sensors; let i = index"
                >
                  {{
                    i === 0
                      ? sensor.motor_serial_no
                      : ", " + sensor.motor_serial_no.substr(-4)
                  }}
                </p>
              </div>

              <div
                *ngIf="device.new !== undefined"
                class="{{ device.asset_type_s }} motorView EditView {{
                  device.asset_type
                }}"
              >
                <div class="motor left {{ device.asset_type }}">
                  <span
                    class="left"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'primary' && sensor.sensor === 'nde'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="center"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'primary' && sensor.sensor === 'frame'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="right"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'primary' && sensor.sensor === 'de'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <img src="{{ device.imgP }}" />
                </div>

                <div
                  class=" motor right {{ device.asset_type_s }}"
                  *ngIf="device.asset_type_s"
                >
                  <span
                    class="left coupleLeft"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'primary' &&
                        sensor.sensor === 'couple'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <!-- <span class="left" *ngFor="let sensor of device.connected_sensors"><button
                          *ngIf="sensor.parent === 'secondry' && sensor.sensor === 'de'"
                          (click)="openDetailScreen(sensor, device)"
                          [style.background-color]="sensor.color">{{SC}}</button></span> -->
                  <span
                    class="left"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'secondry' && sensor.sensor === 'de'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="center"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'secondry' &&
                        sensor.sensor === 'frame'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="right"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="
                        sensor.parent === 'secondry' && sensor.sensor === 'nde'
                      "
                      (click)="openDetailScreen(sensor, device)"
                      matTooltip="{{ sensor.motor_serial_no }}"
                      [style.background-color]="sensor.color"
                      class="numBtn"
                    >
                      {{ sensor.sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <img src="{{ device.imgS }}" />
                </div>
              </div>

              <div class="motorView" *ngIf="device.template_id === '1'">
                <div class="motor left {{ device.asset_type }}">
                  <span
                    class="center_single"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 1"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                </div>
              </div>

              <div class="motorView" *ngIf="device.template_id === '4'">
                <div class="motor left {{ device.asset_type }}">
                  <span
                    class="left"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 2"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="center"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 1"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                      <span
                        *ngIf="sensor.asset_status === 2"
                        class="sprite_iconred wifiIcon wifi_redlabel"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 1"
                        class="sprite_icon wifiIcon wifi_ys"
                      ></span>
                      <span
                        *ngIf="sensor.asset_status === 0"
                        class="sprite_icon wifiIcon wifi_na"
                      ></span></button
                  ></span>
                  <span
                    class="right"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 3"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                      <span *ngIf="sensor.asset_status === 2" class="wifiIcon"
                        ><i class="fa fa-wifi"></i
                      ></span>
                      <span *ngIf="sensor.asset_status === 1" class="wifiIcon"
                        ><i class="fa fa-wifi"></i
                      ></span>
                      <span *ngIf="sensor.asset_status === 0" class="wifiIcon"
                        ><i class="fa fa-wifi"></i
                      ></span></button
                  ></span>

                  <img
                    *ngIf="device.asset_type === 'MOTOR'"
                    src="./assets/motor_n.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'GEAR'"
                    src="./assets/gearbox.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'PUMP'"
                    src="./assets/pump.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'FAN_BLOWER'"
                    src="./assets/fan.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                    src="./assets/bearing2.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'COMPRESSOR'"
                    src="./assets/compressor.png"
                  />
                </div>
              </div>
              <div
                class="motorView {{ device.asset_type }}"
                *ngIf="device.template_id === '5'"
              >
                <div class="motor left">
                  <span
                    class="left_t6_de"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 2"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <span
                    class="center"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 1"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <span
                    class="right_t6_nde"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 3"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <img src="./assets/motor_n.png" />

                  <img
                    *ngIf="device.asset_type === 'GEAR'"
                    src="./assets/gearbox.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'PUMP'"
                    src="./assets/pump.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'FAN_BLOWER'"
                    src="./assets/fan.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                    src="./assets/bearing2.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'COMPRESSOR'"
                    src="./assets/compressor.png"
                  />
                </div>
                <div class="motor right {{ device.asset_type }}">
                  <img
                    *ngIf="device.asset_type === 'MOTOR'"
                    src="./assets/motor_n.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'GEAR'"
                    src="./assets/gearbox.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'PUMP'"
                    src="./assets/pump.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'FAN_BLOWER'"
                    src="./assets/fan.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                    src="./assets/bearing2.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'COMPRESSOR'"
                    src="./assets/compressor.png"
                  />
                </div>
              </div>
              <div
                class="motorView {{ device.asset_type }}"
                *ngIf="device.template_id === '7'"
              >
                <div class="motor left">
                  <span
                    class="left"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 2"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <span
                    class="center"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 1"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <span
                    class="right"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 3"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <img src="./assets/motor_n.png" />
                </div>
                <div class="motor right {{ device.asset_type }}">
                  <img
                    *ngIf="device.asset_type === 'MOTOR'"
                    src="./assets/motor_n.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'GEAR'"
                    src="./assets/gearbox.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'PUMP'"
                    src="./assets/pump.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'FAN_BLOWER'"
                    src="./assets/fan.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                    src="./assets/bearing2.png"
                  />
                  <img
                    *ngIf="device.asset_type === 'COMPRESSOR'"
                    src="./assets/compressor.png"
                  />
                  <span
                    class="left"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 4"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                  <span
                    class="right"
                    *ngFor="let sensor of device.connected_sensors"
                    ><button
                      *ngIf="sensor.device_sno === 5"
                      (click)="openDetailScreen(sensor, device)"
                      [style.background-color]="sensor.color"
                    >
                      {{ sensor.device_sno }}
                    </button></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
